/* import __COLOCATED_TEMPLATE__ from './user-profile-header.hbs'; */
/* RESPONSIBLE TEAM: team-conversations */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/no-actions-hash */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
import { and, not, or } from '@ember/object/computed';
import Component from '@ember/component';
import { ternaryToProperty } from '@intercom/pulse/lib/computed-properties';
import LocationData from 'embercom/controllers/mixins/users-and-admins/location-data';
import { inject as service } from '@ember/service';
import { action, computed } from '@ember/object';
import { taskFor } from 'ember-concurrency-ts';
import { checkConversationCreationPermission } from 'embercom/lib/permissions/conversation-creation';
import { hasFeature } from 'embercom/helpers/has-feature';

export default Component.extend(LocationData, {
  tagName: '',

  // variables that will be used in handlebar tmpl
  isAdminAndMe: and('user.isAdmin', 'user.is_me'),

  shouldShowAvatarUpload: computed(
    'user.{is_me,isAdmin}',
    'appService.app.features.[]',
    function () {
      let isFeatureFlagEnabled = hasFeature('spg-inbox-manage-teammate-profiles', this.appService);

      if (!isFeatureFlagEnabled) {
        return this.get('user.isAdmin') && this.get('user.is_me');
      }

      return this.get('user.isAdmin');
    },
  ),

  // attribute used by LocationData mixin
  modelGeoipData: ternaryToProperty('user.isAdmin', 'user.location_data', 'user.geoip_data'),

  appService: service(),
  router: service(),
  intl: service(),
  permissionsModal: service(),

  // proxy of actions
  actions: {
    onNewConversationClick() {
      if (
        !checkConversationCreationPermission({
          appService: this.appService,
          permissionsModal: this.permissionsModal,
          intl: this.intl,
        })
      ) {
        return;
      }
      this.router.transitionTo('inbox.workspace.inbox.new-conversation', this.app.id, {
        queryParams: {
          overwrite: null,
          recipient: this.user.id,
        },
      });
    },
  },

  navbarCollapsingService: service(),
  commonPrimaryNavBarService: service(),
  messengerInstallation: service(),
  sdkAppService: service(),
  notCollapsable: not('shouldRenderHamburgerMenu'),
  collapsed: or('navbarCollapsingService.collapsed', 'notCollapsable'),

  init() {
    this._super(...arguments);
    if (this.app.hasStandaloneToSuiteMigrationFeature) {
      // used by the messenger installation service to check if the messenger is installed
      taskFor(this.sdkAppService.loadSdkApps)
        .perform()
        .catch(() => {});
    }
  },

  conversationModalClosed: action(function (result) {
    if (result && result.success && this.onConversationStarted) {
      this.onConversationStarted();
    }
  }),

  isExternalUser: computed(
    'user.has_external_reference',
    'app.hasStandaloneToSuiteMigrationFeature',
    function () {
      if (!this.app.hasStandaloneToSuiteMigrationFeature) {
        return false;
      }

      return this.user?.has_external_reference;
    },
  ),

  shouldHideNewConversationButton: computed(
    'isExternalUser',
    'messengerInstallation.isMessengerInstalledAnywhere',
    'user.{email,email_masked}',
    function () {
      if (!this.isExternalUser) {
        return false;
      }

      try {
        let isEmailMasked = this.user?.email_masked ?? false;
        let isContactable =
          (this.user.email && !isEmailMasked) ||
          this.messengerInstallation.isMessengerInstalledAnywhere;
        return !isContactable;
      } catch (error) {
        return false;
      }
    },
  ),
});
